// extracted by mini-css-extract-plugin
module.exports = {"packageContainer":"Package_packageContainer__3Wpxl","packageWrapper":"Package_packageWrapper__kPUCp","sliderWrapper":"Package_sliderWrapper__YNPdf"};